import * as PIXI from 'pixi.js';

export class PixiBase {
  constructor(memoHelper) {
    this.PIXI = window.PIXI || PIXI || PixiBase.PIXI;
    this._memoHelper = memoHelper || PixiBase.memoHelper;
  }

  loadResource(resource, loader) {
    const { source, declared } = this._getFromMemo(resource);
    return new Promise((resolve) => {
      source
        .reduce((
          load,
          { name, path, config },
        ) => load.add(name, path, config), loader)
        .load((loader, res) => {
          if (this._memoHelper) {
            this._memoHelper.declareResources(res);
          }
          resolve({
            res: {
              ...declared,
              ...res,
            },
          });
        });
    });
  }

  _getFromMemo(resource) {
    if (this._memoHelper) {
      const source = this._memoHelper.filter(resource);
      const declared = this._memoHelper.getDeclaredResources(resource);
      return { source, declared };
    }
    return { source: resource, declared: {} };
  }
}
